export interface IChangePassword {
  oldPassword: string;
  newPassword: string;
}
